import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import classnames from 'classnames';
import Checkbox from '@/components/UI/Checkbox';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

export const LenderConfirmBlock = ({ disabled }) => {
  const { t } = useTranslation('fundraising');
  const { values, touched, isSubmitting, errors, handleSubmit, setFieldValue } = useFormikContext();
  return (
    <div className={s.wrapper}>
      <div className={s.checkboxes}>
        <Checkbox
          name="has_accepted_terms"
          isChecked={values.has_accepted_terms}
          onChange={() => setFieldValue('has_accepted_terms', !values.has_accepted_terms)}
          error={touched.has_accepted_terms && errors.has_accepted_terms}
          render={() => (
            <span
              className={classnames(
                'f-14',
                touched.has_accepted_terms && errors.has_accepted_terms && s.error,
              )}
            >
              {t('fundraising:lender.confirm_checkbox')}
            </span>
          )}
        />
      </div>
      <div className={s.buttons}>
        <button
          type="submit"
          disabled={disabled || isSubmitting}
          className={classnames(s.btn_submit, r.black_large, r.shrink_height)}
          onSubmit={handleSubmit}
        >
          {t('fundraising:lender.submit_proposal')}
        </button>
      </div>
    </div>
  );
};
